import { render, staticRenderFns } from "./feedback_logs.vue?vue&type=template&id=a239d858&scoped=true"
import script from "./feedback_logs.vue?vue&type=script&lang=js"
export * from "./feedback_logs.vue?vue&type=script&lang=js"
import style0 from "./feedback_logs.vue?vue&type=style&index=0&id=a239d858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a239d858",
  null
  
)

export default component.exports